import { OrderBlockWrapper } from '../../../Common/OrderBlockWrapper';

import type { ContractDetailsProps } from './types';

import styles from './ContractDetails.module.scss';

export const ContractDetails = ({ children }: ContractDetailsProps): JSX.Element => {
  return (
    <OrderBlockWrapper className={styles.wrapper}>
      <h3 className={styles.title}>Contract Details</h3>
      {children}
    </OrderBlockWrapper>
  );
};
